// extracted by mini-css-extract-plugin
module.exports = {"header":"css_header__36w-F","inner":"css_inner__r2DOS","corner":"css_corner__1zBkC","cell":"css_cell__3-7bM"};